// extracted by mini-css-extract-plugin
export default {"container":"components-payment-method-selection-module__container"};